export function setAtomLabels(mol, drawnMol) {
  for (const [key, drawnAtom] of Object.entries(drawnMol.atoms)) {
    const atom = mol.atoms[key];
    if (atom.element === 'C' && atom.charge === 0 && drawnAtom.data.explicitValence !== 0) {
      continue;
    }

    const centerAtomLabel = [{ text: atom.element, pivot: true }];
    if (atom.charge !== 0) {
      const abs = Math.abs(atom.charge);
      const digits = abs > 1 ? abs : '';
      const sign = atom.charge > 0 ? '+' : '-';
      centerAtomLabel.push({ type: 'super', text: digits + sign, pivot: false });
    }
    drawnAtom.centerLabel = { parts: centerAtomLabel };

    const sideAtomLabel = [];
    const hydrogens = drawnAtom.data.hydrogens == null ? 0 : drawnAtom.data.hydrogens;
    if (hydrogens > 0) {
      sideAtomLabel.push({ text: 'H', pivot: true });
    }
    if (hydrogens > 1) {
      sideAtomLabel.push({ type: 'sub', pivot: false, text: hydrogens.toString() });
    }
    if (sideAtomLabel.length > 0) {
      drawnAtom.sideLabel = { parts: sideAtomLabel };
    }
  }
}
